import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/_dashboard/invoices/recurring-invoices/new/',
)({
  beforeLoad: () => {
    throw redirect({ to: '/invoices/new', search: { recurring: true }, replace: true })
  },
})
